const SITE_URL = 'https://bigsport.com.ua';
const DEFAULT_IMAGE = `${SITE_URL}/logo-w512.png`;
const DEFAULT_ROBOTS = 'index, follow, max-image-preview:large';

const MAIN_ROUTE_SEO = {
  '/': {
    title: 'BigSPORT — спортивні новини України та світу',
    description: 'BigSPORT — український сайт спортивних новин. Футбол України, УПЛ, єврокубки, збірна України, біатлон, бокс, теніс, MMA та світовий спорт.',
    priority: '1.0',
  },
  '/news': {
    title: 'Останні спортивні новини України та світу | BigSPORT',
    description: 'Останні новини футболу, біатлону, боксу, тенісу, MMA та інших видів спорту на BigSPORT.',
    priority: '0.9',
  },
  '/football-ukraine': {
    title: 'Футбол України — новини УПЛ, Кубка та збірної | BigSPORT',
    description: 'Останні новини українського футболу, УПЛ, Кубка України, Першої ліги, клубів та збірної України.',
    priority: '0.9',
  },
  '/championships': {
    title: 'Європейські чемпіонати — АПЛ, Ла Ліга, Серія А | BigSPORT',
    description: 'Новини провідних футбольних чемпіонатів Європи: АПЛ, Ла Ліга, Серія А, Бундесліга та Ліга 1.',
    priority: '0.8',
  },
  '/eurocups': {
    title: 'Єврокубки — Ліга чемпіонів, Ліга Європи | BigSPORT',
    description: 'Останні новини Ліги чемпіонів, Ліги Європи та Ліги конференцій.',
    priority: '0.8',
  },
  '/biathlon': {
    title: 'Біатлон — останні новини, результати та Кубок світу | BigSPORT',
    description: 'Новини біатлону, результати перегонів, Кубок світу, чемпіонати та виступи збірної України.',
    priority: '0.8',
  },
  '/sports': {
    title: 'Бокс, теніс, MMA та інші види спорту | BigSPORT',
    description: 'Останні новини боксу, тенісу, MMA, футзалу та інших видів спорту.',
    priority: '0.8',
  },
  '/tournaments': {
    title: 'Головні футбольні турніри світу | BigSPORT',
    description: 'Новини чемпіонатів світу, Євро, клубних турнірів та інших великих спортивних подій.',
    priority: '0.8',
  },
  '/about': {
    title: 'Про BigSport | Український спортивний портал',
    description: 'Історія BigSport — українського спортивного медіапроєкту, що висвітлює футбол, бокс, теніс, біатлон, ММА та інші види спорту.',
    priority: '0.5',
  },
  '/contacts': {
    title: 'Контакти BigSport | Зв’язок із редакцією',
    description: 'Контакти спортивного порталу BigSport. Надсилайте новини, пресрелізи, пропозиції щодо партнерства, реклами та повідомлення про помилки.',
    priority: '0.5',
  },
  '/privacy-policy': {
    title: 'Політика конфіденційності | BigSport',
    description: 'Політика конфіденційності BigSport: використання cookie-файлів, аналітичних сервісів, Google AdSense, персоналізованої реклами та захист персональних даних.',
    priority: '0.4',
  },
  '/archive': {
    title: 'Архів клубів | BigSport',
    description: 'Архів клубів BigSport. Новини, матеріали та історія команд, які більше не представлені в актуальній структурі розділів українського футболу.',
    priority: '0.6',
  },
  '/authors-ranking': {
    title: 'Рейтинг авторів BigSPORT',
    description: 'Рейтинг авторів спортивного порталу BigSPORT за кількістю матеріалів і переглядів.',
    priority: '0.6',
  },
};

const CATEGORY_ROUTES = {
  'Футбол України': [
    ['УПЛ', '/football-ukraine/upl', '0.9'],
    ['Кубок України', '/football-ukraine/cup', '0.8'],
    ['Збірна України', '/football-ukraine/zbirna', '0.8'],
    ['Перша Ліга', '/football-ukraine/first-league', '0.8'],
    ['Друга Ліга', '/football-ukraine/second-league', '0.8'],
    ['Шахтар', '/football-ukraine/shakhtar'], ['Динамо Київ', '/football-ukraine/dynamo'],
    ['Олександрія', '/football-ukraine/oleksandriya'], ['Кривбас', '/football-ukraine/kryvbas'],
    ['Зоря', '/football-ukraine/zorya'], ['Чорноморець', '/football-ukraine/chornomorets'],
    ['Оболонь', '/football-ukraine/obolon'], ['Колос', '/football-ukraine/kolos'],
    ['Рух', '/football-ukraine/rukh'], ['ЛНЗ', '/football-ukraine/lnz'],
    ['Карпати', '/football-ukraine/karpaty'], ['Інгулець', '/football-ukraine/ingulec'],
    ['Ворскла', '/football-ukraine/vorskla'], ['Полісся', '/football-ukraine/polissya'],
    ['Лівий Берег', '/football-ukraine/lberig'], ['Верес', '/football-ukraine/veres'],
    ['Буковина', '/football-ukraine/bukovyna', '0.6'], ['Вікторія', '/football-ukraine/viktoriya', '0.6'],
    ['Агробізнес', '/football-ukraine/agrobiznes', '0.6'], ['Епіцентр', '/football-ukraine/epitsenter', '0.6'],
    ['Кремінь', '/football-ukraine/kremin', '0.6'], ['ЮКСА', '/football-ukraine/yuksa', '0.6'],
    ['Полтава', '/football-ukraine/poltava', '0.6'], ['Кудрівка', '/football-ukraine/kudrivka', '0.6'],
    ['Поділля', '/football-ukraine/podillya', '0.6'], ['ФК Харків', '/football-ukraine/fc-kharkiv', '0.8'],
    ['Металіст', '/football-ukraine/metalist', '0.6'], ['Нива', '/football-ukraine/nyva', '0.6'],
    ['Фенікс-Маріуполь', '/football-ukraine/fenix-mariupol', '0.6'], ['Металург', '/football-ukraine/metalurh', '0.6'],
    ['Прикарпаття', '/football-ukraine/prykarpattia', '0.6'], ['Діназ', '/football-ukraine/dinaz', '0.6'],
    ['Минай', '/football-ukraine/minai', '0.6'], ['Чернігів', '/football-ukraine/chernihiv', '0.6'],
    ['Гірник-Спорт', '/football-ukraine/hirnyk-sport', '0.6'], ['Пробій', '/football-ukraine/probiy', '0.6'],
    ['Реал Фарма', '/football-ukraine/real-pharma', '0.6'], ['Локомотив', '/football-ukraine/lokomotiv', '0.6'],
    ['Лісне', '/football-ukraine/lisne', '0.6'], ['Скала 1911', '/football-ukraine/skala-1911', '0.6'],
    ['ФК Ужгород', '/football-ukraine/uzhorod', '0.6'], ['Куликів-Білка', '/football-ukraine/kulykiv-bilka', '0.6'],
    ['Нива Вінниця', '/football-ukraine/nyva-vinnytsia', '0.6'], ['Атлет', '/football-ukraine/atlet', '0.6'],
    ['Вільхівці', '/football-ukraine/vilkhivtsi', '0.6'], ['Ребел', '/football-ukraine/rebel', '0.6'],
    ['Тростянець', '/football-ukraine/trostyanets', '0.6'], ['Пенуел', '/football-ukraine/penuel', '0.6'],
    ['Брацлав', '/football-ukraine/bratslav', '0.6'], ['Дністер', '/football-ukraine/dnister-zalishchyky', '0.6'],
    ['Авангард', '/football-ukraine/avangard-lozova', '0.6'], ['Карбон', '/football-ukraine/carbon-cherkasy', '0.6'],
  ],
  Чемпіонати: [
    ['Європейські новини', '/championships/europe-news'], ['Світовий футбол', '/world-football/global'],
    ['Англійська Премʼєр-ліга', '/championships/epl', '0.8'], ['Іспанська Ла Ліга', '/championships/la-liga', '0.8'],
    ['Італійська Серія А', '/championships/seriaA', '0.8'], ['Німецька Бундесліга', '/championships/bundesliga', '0.8'],
    ['Французька Ліга 1', '/championships/ligue1', '0.8'],
  ],
  Єврокубки: [
    ['Ліга Чемпіонів', '/eurocups/champions-league', '0.8'],
    ['Ліга Європи', '/eurocups/europa-league', '0.8'],
    ['Ліга Конференцій', '/eurocups/conference-league', '0.8'],
  ],
  Біатлон: [
    ['Новини', '/biathlon/news-biathlon'], ['Кубок Світу', '/biathlon/world-cup', '0.8'],
    ['Кубок IBU', '/biathlon/ibu-cup'], ['Чемпіонат Світу', '/biathlon/world-championship', '0.8'],
  ],
  'Види спорту': [
    ['Бокс', '/sports/boxing'], ['Теніс', '/sports/tennis'],
    ['MMA', '/sports/mma'], ['Футзал', '/sports/futsal'],
  ],
  Турніри: [
    ['Клубний чемпіонат світу 2025', '/tournaments/club-world-cup-2025'],
    ['Чемпіонат світу 2026', '/tournaments/world-cup-2026', '0.8'],
    ['Чемпіонат Європи з футзалу 2026', '/tournaments/futsal-euro-2026', '0.8'],
  ],
};

const ROUTE_SEO = { ...MAIN_ROUTE_SEO };
Object.entries(CATEGORY_ROUTES).forEach(([category, routes]) => {
  routes.forEach(([section, path, priority = '0.7']) => {
    ROUTE_SEO[path] = {
      title: `${section} — новини ${category} | BigSPORT`,
      description: `Останні новини, результати та матеріали розділу ${section} у категорії ${category} на BigSPORT.`,
      priority,
    };
  });
});

module.exports = {
  CATEGORY_ROUTES,
  DEFAULT_IMAGE,
  DEFAULT_ROBOTS,
  ROUTE_SEO,
  SITE_URL,
};
